import "@/App.css";
import React from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import JudgeScreen from "@/pages/JudgeScreen";
import AdminDashboard from "@/pages/AdminDashboard";
import AppHeader from "@/components/AppHeader";

function Shell() {
  const { user, loading, mode } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#070B14]">
        <div className="text-amber-400 font-display text-xl animate-pulse">Loading KWC Luzon…</div>
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <div className="min-h-screen bg-[#070B14]">
      <AppHeader />
      {mode === "superadmin" && user.is_superadmin ? <AdminDashboard /> : <JudgeScreen />}
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Shell />
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
